import { enabledApplicationList } from './reducers/enabled-applicaton/enabled-application-list.reducer';
import { enabledApplicationParams } from './reducers/enabled-applicaton/enabled-application-params.reducer';
import { expandedApplicationList } from './reducers/expanded-application/expanded-application-list.reducer';
import { loadingStatus } from './reducers/loading-status.reducer';
import { loadingError } from './reducers/loading-error.reducer';
import { applicationDetails } from './reducers/application-details/application-details.reducer';
import { ApplicationsState } from './applications.state';
import { ActionReducerMap } from '@ngrx/store';
import { updatePermissions } from './reducers/enabled-applicaton/application-update-permissions.reducer';
import { backupApplicationDetails } from './reducers/backup-application-details/backup-application-details.reducer';

/**
 * Applications store.
 */
export const applications: ActionReducerMap<ApplicationsState> = {
    enabledApplicationList,
    enabledApplicationParams,
    expandedApplicationList,
    applicationDetails,
    backupApplicationDetails,
    updatePermissions,
    loadingStatus,
    loadingError
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/applications.store.ts